function getObjValues(enumType: any): (number | string)[] {
	return Object.keys(enumType).map(k => enumType[k]);
}

function getNames(enumType: any) {
	return getObjValues(enumType).filter(v => typeof v === 'string') as string[];
}

export function getNamesAndValues<T extends number>(enumType: any) {
	return getNames(enumType).map(n => ({ name: n, value: enumType[n] as T }));
}

export function getName<T extends number>(enumType: any, value: T) {
	return getNames(enumType).filter(n => enumType[n] === value)[0];
}

export function getValues<T extends number>(enumType: any) {
	return getObjValues(enumType).filter(v => typeof v === 'number') as T[];
}

export function getValue<T extends number>(enumType: any, name: string): T {
	return getNamesAndValues(enumType).filter(x => x.name === name)[0].value as T;
}
